import Title from "components/Title";
import * as S from "./styles";
import AgentType from "utils/agentType";
import TableParams from "components/TableParams";
import TableParamsHistory from "components/TableParamsHistory";
function Params() {
  const agentType = AgentType();

  return (
    <>
      <S.Box>
        <Title
          titleText="Parâmetros do sistema"
          subtitleTexts={["Início", "Parâmetros do sistema"]}
        />
        <S.DescriptionBox>
          <p>
            Tela responsável por visualizar e editar os valores de parâmetros
            que definem critérios operacionais do sistema, incluindo limites de
            renda, prazos e regras de elegibilidade, assegurando alinhamento com
            as diretrizes e necessidades do programa.
          </p>
        </S.DescriptionBox>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <TableParams />
          {['1'].includes(agentType) &&
            <TableParamsHistory />}
        </div>
      </S.Box>
    </>
  );
}

export default Params;
